import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import EngagementReport from '../modules/engagement_report/engagement_reports/EngagementReport';
// import EngagementReports from "./EngagementReports";
import EngagementStats from "./EngagementStats";
import EngagementSumary from "./EngagementSummary";
// in=mport


function EngagementRep() {
  return (
    <div>
      <Tabs
        variant="pills"
        defaultActiveKey="home"
        id="uncontrolled-tab-example"
        className="pb-3  border-bottom border-2 text-white "
      >
        <Tab eventKey="home" title="Engagement Report" className="tab-item">
            <EngagementReport />

        </Tab>
        {/* <Tab eventKey="profile" title="Engagement Stats" className="tab-item">
            <EngagementStats />
        </Tab>
        <Tab
          eventKey="contact"
          title="Engagement Summary"
          className="tab-item"
        >
            <EngagementSumary />
        </Tab> */}
      </Tabs>
    </div>
  );
}

export default EngagementRep;
